if (!customElements.get('hollow-product-offers')) {
  customElements.define('hollow-product-offers', class HollowProductOffers extends HTMLElement {
    connectedCallback() {
      this.quantity = this.quantity || 1;
      this.productInfo = this.closest('product-info');
      this.onClick = (event) => {
        const offer = event.target.closest('[data-quantity]');
        if (offer) this.select(Number(offer.dataset.quantity));
      };
      this.onKey = (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const offers = [...this.querySelectorAll('[data-quantity]')];
        const index = offers.indexOf(event.target.closest('[data-quantity]'));
        if (index < 0) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? offers.length - 1 : (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + offers.length) % offers.length;
        this.select(Number(offers[next].dataset.quantity));
        offers[next].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const updated = data.html.getElementById(this.id);
        const focusedOffer = this.contains(document.activeElement)
          ? document.activeElement.closest('[data-quantity]')?.dataset.quantity : null;
        if (updated) this.innerHTML = updated.innerHTML;
        this.select(this.quantity);
        if (focusedOffer) this.querySelector(`[data-quantity="${focusedOffer}"]`)?.focus({ preventScroll: true });
      });
      this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.select(this.quantity));
      this.select(this.quantity);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.unsubscribeVariant?.();
      this.unsubscribeQuantity?.();
    }
    select(quantity) {
      const selected = this.querySelector(`[data-quantity="${quantity}"]`);
      if (!selected) return;
      this.quantity = quantity;
      this.querySelectorAll('[data-quantity]').forEach((offer) => {
        const active = offer === selected;
        offer.classList.toggle('is-active', active);
        offer.setAttribute('aria-checked', String(active));
        offer.tabIndex = active ? 0 : -1;
      });
      const nativeQuantity = this.productInfo.querySelector('.quantity__input');
      if (nativeQuantity) nativeQuantity.value = quantity;
      const price = this.productInfo.querySelector('[data-hollow-atc-price]');
      if (price) {
        price.replaceChildren(document.createTextNode(' · '));
        if (quantity > 1) {
          const compare = document.createElement('s');
          compare.textContent = selected.dataset.compare;
          price.append(compare);
        }
        price.append(document.createTextNode(selected.dataset.total));
      }
    }
  });
}

// Native slider/thumbnail controls remain responsible for slide selection.
// This adds desktop pointer dragging to the same scrollable track.
if (!document.documentElement.hasAttribute('data-hollow-product-drag')) {
  document.documentElement.setAttribute('data-hollow-product-drag', '');
  document.addEventListener('click', (event) => {
    const nav = event.target.closest('[data-hollow-gallery-nav]');
    if (!nav) return;
    const gallery = nav.closest('media-gallery');
    const thumbs = [...gallery.querySelectorAll('.hollow-pdp-gallery__thumb')];
    const index = Math.max(0, thumbs.findIndex((item) => item.querySelector('[aria-current]')));
    const next = (index + Number(nav.dataset.hollowGalleryNav) + thumbs.length) % thumbs.length;
    gallery.setActiveMedia(thumbs[next].dataset.target, false);
  });
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = event.target.closest('.hollow-pdp-gallery__slides');
    if (!track) return;
    event.preventDefault();
    const startX = event.clientX;
    const initial = track.scrollLeft;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    track.style.cursor = 'grabbing';
    let delta = 0;
    const move = (e) => {
      if (e.pointerId !== event.pointerId) return;
      if (!(e.buttons & 1)) { finish(); return; }
      delta = startX - e.clientX;
      track.scrollLeft = initial + delta;
    };
    const onVisibilityChange = () => { if (document.hidden) finish({ type: 'visibilitychange' }); };
    const finish = (endEvent) => {
      if (endEvent?.pointerId !== undefined && endEvent.pointerId !== event.pointerId) return;
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', finish);
      window.removeEventListener('pointercancel', finish);
      window.removeEventListener('blur', finish);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      track.style.cursor = '';
      const width = track.clientWidth;
      const slides = [...track.querySelectorAll('[data-media-id]')];
      if (!track.isConnected || !width || !slides.length) return;
      const initialIndex = Math.round(initial / width);
      const cancelled = ['blur', 'visibilitychange', 'pointercancel'].includes(endEvent?.type);
      const nextIndex = (initialIndex + (!cancelled && Math.abs(delta) > 30 ? Math.sign(delta) : 0) + slides.length) % slides.length;
      track.closest('media-gallery').setActiveMedia(slides[nextIndex].dataset.mediaId, false);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', finish);
    window.addEventListener('pointercancel', finish);
    window.addEventListener('blur', finish);
    document.addEventListener('visibilitychange', onVisibilityChange);
  });
}
